<div>
  <label :for="inputId" class="bold">{{ label }}</label>
  <input
    :id="inputId"
    :type="inputType"
    :value="formattedValue"
    @input="onInput"
    @blur="onBlur"
    :class="[{ 'outline-danger': errorMessage}]"
    class="input"
  />
  <span v-if="errorMessage" class="mb0 txt-danger font14 mt3">{{ errorMessage }}</span>
</div>
